import React, { useState } from 'react';
import './NewsLetter.css';

const NewsLetter = () => {
  const [email, setEmail] = useState('');
  const [responseMsg, setResponseMsg] = useState('');

  const handleSubscribe = async () => {
    if (!email) {
      setResponseMsg("Kérlek adj meg egy email címet.");
      return;
    }

    const res = await fetch("/api/subscribe", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ email })
    });

    const data = await res.json();
    setResponseMsg(data.message || "Hiba történt.");
    setEmail('');
  };

  return (
    <div className="newsletter">
      <h1>Értesülj először az akciókról</h1>
      <p>Iratkozz fel a hírlevelünkre</p>
      <div>
        <input
          type="email"
          placeholder='Email címed'
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <button onClick={handleSubscribe}>Feliratkozás</button>
      </div>
      {responseMsg && <p className="newsletter-response">{responseMsg}</p>}
    </div>
  );
};

export default NewsLetter;
